"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentType = void 0;
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["Mangopay"] = 0] = "Mangopay";
    PaymentType[PaymentType["Paypal"] = 1] = "Paypal";
    PaymentType[PaymentType["Other"] = 2] = "Other";
    PaymentType[PaymentType["Cash"] = 3] = "Cash";
    PaymentType[PaymentType["BankTransaction"] = 4] = "BankTransaction";
    PaymentType[PaymentType["Checkout"] = 5] = "Checkout";
    PaymentType[PaymentType["Stripe"] = 6] = "Stripe";
    PaymentType[PaymentType["StatementOfBooking"] = 7] = "StatementOfBooking";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
//# sourceMappingURL=PaymentType.js.map